export const ProficiencyLevel = {
    JUNIOR: 'Junior',
    EVOLUTION: 'Evolution',
    SATISFACTORY: 'Satisfactory',
    ADVANCED: 'Advanced',
    EXPERT: 'Expert',
} as const;

export type ProficiencyLevelType = (typeof ProficiencyLevel)[keyof typeof ProficiencyLevel];

// Ordered from the lowest (Junior) to the highest (Expert) expectation.
export const proficiencyLevels: ProficiencyLevelType[] = [
    ProficiencyLevel.JUNIOR,
    ProficiencyLevel.EVOLUTION,
    ProficiencyLevel.SATISFACTORY,
    ProficiencyLevel.ADVANCED,
    ProficiencyLevel.EXPERT,
];
